<template>
    <div>
        <template v-if="!loading">
            <div class="box">
                <h3><i></i>试题错误率</h3>
                <div class="scoreChartWarp">
                    <div id="scoreChart"
                         :style="echartStyle"></div>
                </div>
            </div>
            <div class="taskList">
                <simpleResult text="暂无错题"
                              :sid="sid"
                              :question_list="list"
                              :haveMore="false"
                              @childClick="childClick"
                              status="task"></simpleResult>
            </div>
        </template>
        <loadings v-else></loadings>
    </div>
</template>
<script>
import * as echarts from 'echarts';
import loadings from "COMPONENTS/base/loadingS.vue";
import simpleResult from 'VIEWS/personaLearning/simpleResult/index.vue';
export default {
    props: ['message_id', 'unit_class_id', 'sid'],
    data () {
        return {
            list: [],
            xData: [],
            seriesData: [[], []],
            loading: true,
            echartStyle: {
                width: '15rem',
                height: '9.5rem'
            }
        }
    },
    components: {
        loadings,
        simpleResult
    },
    created () {
        this.getWrongDetail()
    },
    mounted () {

    },
    methods: {
        getWrongDetail () {
            let url = '', data = {};
            if (this.$route.query.testType == "qz") {
                url = API_URL_HD_API + "/qz2022/tea/wrong_detail"
                data = {
                    "paper_id": this.message_id,
                    "sid": this.sid,
                    "unit_class_id": this.unit_class_id
                }
            }
            else if (this.$route.query.testType == "qm") {
                url = API_URL_HD_API + "/qm2022_down/tea/wrong_detail"

                data = {
                    "paper_id": this.message_id,
                    "sid": this.sid,
                    "unit_class_id": this.unit_class_id
                }
            } else if (this.$route.query.taskType == "2022winter") {
                url = API_URL_HD_API + "/winter2022/tea/wrong_detail"
                data = {
                    "paper_id": this.message_id,
                    "sid": this.sid,
                    "unit_class_id": this.unit_class_id
                }
            } else if (this.$route.query.taskType == "2023winter" || this.$route.query.taskType == "2024winter") {
                url = API_URL_HD_API + "/winter2023/tea/wrong_detail"
                data = {
                    "paper_id": this.message_id,
                    "sid": this.sid,
                    "unit_class_id": this.unit_class_id
                }
            } else if (this.$route.query.taskType == "2023kxjc") {
                url = API_URL_HD_API + "/kxjc2023/tea/wrong_detail"
                data = {
                    "paper_id": this.message_id,
                    "sid": this.sid,
                    "unit_class_id": this.unit_class_id
                }
            } else if (this.$route.query.taskType == "2023jdjc") {
                url = API_URL_HD_API + "/common/tea/wrong_detail"
                data = {
                    "hd_type": 5,
                    "paper_id": this.message_id,
                    "sid": this.sid,
                    "unit_class_id": this.unit_class_id
                }
            } else if (this.$route.query.hd_type) {
                url = API_URL_HD_API + "/common/tea/wrong_detail"
                data = {
                    "hd_type": this.$route.query.hd_type,
                    "paper_id": this.message_id,
                    "sid": this.sid,
                    "unit_class_id": this.unit_class_id
                }
            } else {

                if (this.sid == 21) {
                    url = API_URL_TASK_API + '/maths/check/special/task_wrong_detail/'
                }
                if (this.sid == 51) {
                    url = API_URL_TASK_API + '/chinese/check/special/task_wrong_detail/'
                }
                data = {
                    message_id: this.message_id,
                    unit_class_id: this.unit_class_id
                }
            }
            this.$http.post(url, data).then(res => {
                this.loading = false;
                if (res.data.response == 'ok') {
                    res = res.data;
                    this.list = res.data.q_list;
                    this.list.forEach((l, i) => {
                        this.xData.push(`第${Number(i + 1)}题`);
                        this.seriesData[0].push(l.wrong_rate);
                        this.seriesData[1].push(l.grade_wrong_rate);
                    })
                    if (this.xData.length) {
                        let n = Math.ceil(this.xData.length / 8);
                        this.echartStyle.width = Number(15 * n) + 'rem';
                    }
                    this.$nextTick(function () {
                        if (this.sid == 21 || this.sid == 22) {
                            MathJax.Hub.Typeset(document.body)
                        }
                        this.initChart()
                    })
                    // //console.log(this.xData,this.seriesData)
                }
            })
        },
        // getWrongDetail () {
        //     let url = ''
        //     let data = {}
        //     if (this.sid == 51) {
        //         url = "/chinese/check/question/task/report"
        //         data = {
        //             message_id: this.message_id,
        //             unit_class_id: this.unit_class_id,
        //         }
        //         this.$http.post(API_URL_TASK_API + url, data).then(res => {
        //             this.loading = false;
        //             if (res.data.response == 'ok') {
        //                 //console.log(res)
        //                 this.list = res.data.data
        //                 this.list.forEach((l, i) => {
        //                     this.xData.push(l.question_name + '题');
        //                     this.seriesData[0].push(l.wrong_rate);
        //                     this.seriesData[1].push(l.grade_wrong_rate);
        //                 })
        //                 if (this.xData.length) {
        //                     let n = Math.ceil(this.xData.length / 8);
        //                     this.echartStyle.width = Number(15 * n) + 'rem';
        //                 }
        //                 this.$nextTick(function () {
        //                     if (this.sid == 21 || this.sid == 22) {
        //                         MathJax.Hub.Typeset(document.body)
        //                     }
        //                     this.initChart()
        //                 })
        //             }
        //         })
        //     }
        //     else if (this.sid == 21) {
        //         url = "/maths/check/task/report"
        //         data = {
        //             message_id: this.message_id,
        //             unit_class_id: this.unit_class_id,
        //             sid: this.sid
        //         }
        //         this.$http.post(API_URL_TASK_API + url, data).then(res => {
        //             this.loading = false;
        //             if (res.data.response == 'ok') {
        //                 //console.log(res)
        //                 this.list = res.data.data.asks
        //                 this.list.forEach((l, i) => {
        //                     this.xData.push(l.title + '题');
        //                     this.seriesData[0].push(l.wr);
        //                     this.seriesData[1].push(l.wrong_num);
        //                 })
        //                 //console.log(this.xData)
        //                 if (this.xData.length) {
        //                     let n = Math.ceil(this.xData.length / 8);
        //                     this.echartStyle.width = Number(15 * n) + 'rem';
        //                 }
        //                 this.$nextTick(function () {
        //                     if (this.sid == 21 || this.sid == 22) {
        //                         MathJax.Hub.Typeset(document.body)
        //                     }
        //                     this.initChart()
        //                 })
        //             }
        //         })
        //     }

        // },
        initChart () {
            let _this = this;
            let chartDom = document.getElementById('scoreChart');
            let myChart = echarts.init(chartDom);
            let option = {
                // tooltip: {
                //     trigger: 'axis',
                //     axisPointer: {
                //         type: 'cross',
                //         crossStyle: {
                //             color: '#999'
                //         }
                //     }
                // },
                grid: {
                    left: '0.5rem',
                    right: '-40rem',
                    bottom: '0.5rem',
                    containLabel: true
                },
                legend: {
                    selectedMode: false,
                    data: ['班级平均', '年级平均'],
                    right: '1%'
                },
                xAxis: [{
                    type: 'category',
                    data: _this.xData,
                    axisLabel: {
                        interval: 0,
                        textStyle: {
                            fontSize: '12'      //更改坐标轴文字大小
                        }
                    }
                }],
                yAxis: [{
                    type: 'value',
                    min: 0,
                    max: 100,
                    interval: 20,
                    axisLabel: {
                        formatter: '{value} %'
                    }
                }, {
                    type: 'value',
                    min: 0,
                    max: 100,
                    interval: 20,
                    axisLabel: {
                        formatter: '{value} %'
                    }
                }],
                series: [{
                    name: '班级平均',
                    type: 'bar',
                    label: {
                        show: true,
                        position: 'top'
                    },
                    itemStyle: {
                        color: '#ff5a5a'
                    },
                    data: _this.seriesData[0]
                }, {
                    name: '年级平均',
                    type: 'line',
                    yAxisIndex: 1,
                    itemStyle: {
                        color: '#8cd33b'
                    },
                    data: _this.seriesData[1]
                }]
            };
            option && myChart.setOption(option);
        },
        childClick (data) {
            // this.$store.state.setTeaTaskQuestion=this.list;
            localStorage.setItem('teaTaskQuestion', JSON.stringify(this.list))
            this.$router.push(`/personaLearning/taskdetail?sid=${this.sid}&index=${data.index}`);
        },
    },
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
.box {
    width: 600px / $ppr;
    margin: 25px / $ppr auto 30px / $ppr;
    background: #fff;
    padding: 30px / $ppr 30px / $ppr 46px / $ppr;
    border-radius: 16px / $ppr;
    h3 {
        font-size: 30px / $ppr;
        margin-bottom: 24px / $ppr;
        line-height: 56px / $ppr;
        height: 56px / $ppr;
        position: relative;
        padding-left: 48px / $ppr;
        font-weight: bold;
        i {
            position: absolute;
            left: 0;
            top: 50%;
            margin-top: -16px / $ppr;
            display: block;
            width: 32px / $ppr;
            height: 32px / $ppr;
            background: url("../img/icon03.png") 0 0 no-repeat;
            background-size: 100% 100%;
            // vertical-align: middle;
            // margin-right:16px/$ppr;
        }
    }
}
ul li {
    width: 600px / $ppr;
    padding: 24px / $ppr 30px / $ppr;
    background: #fff;
    border-radius: 16px / $ppr;
    margin: 0 auto 30px / $ppr;
    line-height: 50px / $ppr;
    h3 {
        line-height: 54px / $ppr;
        height: 54px / $ppr;
        font-size: 28px / $ppr;
        margin-bottom: 10px / $ppr;
    }
    p {
        line-height: 48px / $ppr;
    }
    div.wrong {
        color: #999;
        font-size: 24px / $ppr;
        line-height: 48px / $ppr;
        padding-top: 10px / $ppr;
        span {
            display: block;
            float: left;
            &:nth-child(2) {
                float: right;
            }
        }
    }
}
.scoreChartWarp {
    width: 600px / $ppr;
    margin: 0 auto;
    overflow-x: auto;
}
.taskList {
    width: 660px / $ppr;
    margin: 0 auto;
}
</style>
